/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactEasing
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _vendorEasing = require('./vendor/easing');

var _vendorEasing2 = _interopRequireDefault(_vendorEasing);

exports['default'] = _vendorEasing2['default'];
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/Easing/Easing.winjs.js
 **/